import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCardsStackFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M440-600h240q17 0 28.5-11.5T720-640q0-17-11.5-28.5T680-680H439q-17 0-28 11.5T400-640q0 17 11.5 28.5T440-600Zm0 120h120q17 0 28.5-11.5T600-520q0-17-11.5-28.5T560-560H439q-17 0-28 11.5T400-520q0 17 11.5 28.5T440-480ZM218-121q-33 5-58-15t-30-53L81-546q-5-32 15.5-58t52.5-31h11v235q0 66 47 113t113 47h440q-8 21-24.5 35.5T695-187l-477 66Zm102-195q-33 0-56.5-23.5T240-396v-364q0-33 23.5-56.5T320-840h480q33 0 56.5 23.5T880-760v364q0 33-23.5 56.5T800-316H320Z" })
});
export default SvgCardsStackFill;
